import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, concatMap, mergeMap } from 'rxjs/operators';
import { Observable, EMPTY, of } from 'rxjs';
import { MassiveEditConformanceGiasActions } from './massive-edit-conformance-gias.actions';
import { GiasAssessmentService } from '../../service/gias-assessment.service';
import { ConfermanceGiasService } from '../../service/confermance-gias.service';


@Injectable()
export class MassiveEditConformanceGiasEffects {

  loadGiasAssessment$ = createEffect(
    (cd: GiasAssessmentService = inject(GiasAssessmentService)) => {
      return this.actions$.pipe(

        ofType(MassiveEditConformanceGiasActions.loadMassiveEditGias),
        mergeMap(({ campaignId, parameters, attestationId, legalEntityIds }) =>
          cd.getGiasAssessment(campaignId, attestationId, legalEntityIds as string[], parameters).pipe(
            map((giasAssessments) => {
              return MassiveEditConformanceGiasActions.loadMassiveEditGiasSuccess({
                giasAssessments
              });
            }),
            catchError((error) => of(MassiveEditConformanceGiasActions.loadMassiveEditGiasFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  loadAllGiasAssessment$ = createEffect(
    (cd: GiasAssessmentService = inject(GiasAssessmentService)) => {
      return this.actions$.pipe(

        ofType(MassiveEditConformanceGiasActions.loadAllMassiveEditGias),
        mergeMap(({ campaignId, parameters, attestationId, legalEntityIds }) =>
          cd.getGiasAssessment(campaignId, attestationId, legalEntityIds ?? null, parameters).pipe(
            map((giasAssessments) => {
              return MassiveEditConformanceGiasActions.loadAllMassiveEditGiasSuccess({
                giasAssessments
              });
            }),
            catchError((error) => of(MassiveEditConformanceGiasActions.loadAllMassiveEditGiasFailure({ error })))
          )
        )
      );
    },
    { functional: true }
  );

  createAndSignAssessment$ = createEffect(
    (cd: GiasAssessmentService = inject(GiasAssessmentService)) => {
      return this.actions$.pipe(
        ofType(MassiveEditConformanceGiasActions.createAndSignMassiveEdit),
        mergeMap(({ campaignId, legalEntityTrackingId, input, attestationId }) =>
          cd.createAndSignAssessment(campaignId, legalEntityTrackingId, input).pipe(
            mergeMap((giasAssessments) =>
              of(
                MassiveEditConformanceGiasActions.createAndSignMassiveEditSuccess({ giasAssessments }),
                MassiveEditConformanceGiasActions.loadAllMassiveEditGias({
                  attestationId, campaignId, parameters: {
                    page: 0, rows: 10000000, filters: {}, order: { sortDirection: 'ASC', sortField: null }, search: null
                  }
                })
              )
            ),
            catchError((error) =>
              of(MassiveEditConformanceGiasActions.createAndSignMassiveEditFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );


  initialMassiveEdit$ = createEffect(
    (cd: ConfermanceGiasService = inject(ConfermanceGiasService)) => {
      return this.actions$.pipe(
        ofType(MassiveEditConformanceGiasActions.initialMassiveEdit),
        mergeMap(({ campaignId, legalEntityTrackingIds, sourceLegalEntity }) =>
          cd.initialMassiveEdit(campaignId, legalEntityTrackingIds, sourceLegalEntity).pipe(
            mergeMap((massiveEdit) =>
              of(
                MassiveEditConformanceGiasActions.initialMassiveEditSuccess({ massiveEdit })
              )
            ),
            catchError((error) =>
              of(MassiveEditConformanceGiasActions.initialMassiveEditFailure({ error }))
            )
          )
        )
      );
    },
    { functional: true }
  );


  constructor(private actions$: Actions) { }
}
